// eslint-disable-next-line no-restricted-imports
import API from 'app/gamma/src/api';
// eslint-disable-next-line no-restricted-imports
import { MemberResponse } from 'app/gamma/src/types/responses';
// eslint-disable-next-line no-restricted-imports
import { StandardThunkAction, Dispatch } from 'app/gamma/src/types';
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from '@trello/redux';
import { featureFlagClient } from '@trello/feature-flag-client';
import { client } from '@trello/graphql';
import { MEMBER_FIELDS_HEADER } from './fields';
// eslint-disable-next-line no-restricted-imports
import { State } from 'app/gamma/src/modules/types';
import {
  LoadHeaderDocument,
  LoadHeaderQuery,
  LoadHeaderQueryVariables,
} from './LoadHeaderQuery.generated';

// Action types
export const LOAD_HEADER_REQUEST = Symbol('loaders/LOAD_HEADER_REQUEST');
export const LOAD_HEADER_SUCCESS = Symbol('loaders/LOAD_HEADER_SUCCESS');
export const LOAD_HEADER_ERROR = Symbol('loaders/LOAD_HEADER_ERROR');

export type LoadHeaderRequestAction = Action<
  typeof LOAD_HEADER_REQUEST,
  string
>;
export type LoadHeaderSuccessAction = Action<
  typeof LOAD_HEADER_SUCCESS,
  MemberResponse
>;
export type LoadHeaderErrorAction = Action<typeof LOAD_HEADER_ERROR, Error>;

// Action creators
const loadHeaderRequest = actionCreator<LoadHeaderRequestAction>(
  LOAD_HEADER_REQUEST,
);
const loadHeaderSuccess = actionCreator<LoadHeaderSuccessAction>(
  LOAD_HEADER_SUCCESS,
);
const loadHeaderError = actionCreator<LoadHeaderErrorAction>(LOAD_HEADER_ERROR);

export const loadHeader = (idMember: string): StandardThunkAction => {
  return async (dispatch: Dispatch, getState: () => State) => {
    dispatch(loadHeaderRequest(idMember));

    const useGraphQL = featureFlagClient.get(
      'fep.use-graphql-for-header-loader',
      false,
    );
    if (!useGraphQL) {
      try {
        const member = await API.client.rest.get<MemberResponse>(
          `members/${idMember}`,
          {
            query: {
              boardStars: true,
              channels: true,
              campaigns: true,
              enterprises: true,
              enterpriseLicenses: true,
              enterprise_fields: 'name,displayName,organizationPrefs',
              enterprise_filter: 'saml,member,member-unconfirmed',
              fields: MEMBER_FIELDS_HEADER,
              missedTransferDate: true,
              enterpriseToExplicitlyOwnBoards: true,
              notifications: 'all',
              notifications_display: true,
              notifications_limit: 10,
              organizations: 'all',
              organization_fields:
                'name,displayName,idEnterprise,memberships,products',
              organization_enterprise: true,
              savedSearches: true,
            },
            headers: { 'X-Trello-Operation-Name': 'loadHeader' },
          },
        );

        dispatch(loadHeaderSuccess(member));
      } catch (err) {
        dispatch(loadHeaderError(err));
      }
    } else {
      const { data, error } = await client.query<
        LoadHeaderQuery,
        LoadHeaderQueryVariables
      >({
        query: LoadHeaderDocument,
        variables: {
          id: idMember,
        },
        context: {
          operationName: 'LoadHeader',
          document: LoadHeaderDocument,
        },
        // eslint-disable-next-line @trello/disallow-fetch-policies
        fetchPolicy: 'network-only',
      });
      if (error) {
        dispatch(loadHeaderError(error));
      } else {
        const member = data.member;

        if (!member) {
          return;
        }

        // Casting as any here is a result of converting the fetching of data from a
        // Gamma network call (explicit types) to an Apollo GraphQL call (looser types)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        dispatch(loadHeaderSuccess(member as any));
      }
    }
  };
};
